import Axios from '@/axios'


export const delivery = function (data={}) {
  return Axios({
    url: '/adminapi/v1/delivery',
    method: 'post',
    data,
  })
}
